import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { useStore } from "@/store";

export const Route = createFileRoute("/app/companies/$company_id/sections/$section_id")({
  beforeLoad: async ({ params }) => {
    // Verify section exists for company and check onboarding status using store
    const { fetchCompanies, getCompanyById } = useStore.getState();
    await fetchCompanies({ force: false });
    const company = getCompanyById(params.company_id);

    if (!company) {
      redirect({
        to: "/app",
        throw: true,
      });
    }

    // Check onboarding completion
    if (!company?.onboarding_completed) {
      redirect({
        to: "/app/companies/$company_id/onboarding",
        params: { company_id: params.company_id },
        throw: true,
      });
    }

    // Verify section exists (company is guaranteed to be non-null after the check above)
    const sections = Array.isArray(company!.sections) ? company!.sections : [];
    const section = sections.find((s) => s.id === params.section_id);

    if (!section) {
      // Redirect to first section if section not found
      const sortedSections = [...sections].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      if (sortedSections.length > 0) {
        redirect({
          to: "/app/companies/$company_id/sections/$section_id/dashboard",
          params: {
            company_id: params.company_id,
            section_id: sortedSections[0].id ?? "",
          },
          throw: true,
        });
      } else {
        redirect({
          to: "/app",
          throw: true,
        });
      }
    }
  },
  component: Outlet,
});
